import React from 'react';
import { checkRoleAccess } from './check-role-access.util';
import { RbacPermission, rbacRules } from './rbac-rules.c';

type Props = {
  /** The role of the current user */
  role: keyof typeof rbacRules | undefined;
  /** The permission to perform (e.g. rbacPermissions.CREATE__PROGRAM) */
  perform: RbacPermission;
  /** The data to be evaluated for dynamic permissions */
  data?: any;
  /** The component to render if user has permission to [perform] */
  yes: React.ReactNode;
  /** The component to render if user was denied permission to [perform] */
  no?: React.ReactNode;
};

export const Can = (props: Props) => {
  return <>{checkRoleAccess(rbacRules, props.role || '', props.perform, props.data) ? props.yes : props.no}</>;
};
